import React from "react";
import "../styles/TermsPage.css";

const TermsPage = () => {
  return (
    <div className="terms-page">
      <section className="terms-hero">
        <h1>Terms & Conditions</h1>
        <p>Understand our policies before you ride with SAC MTB 🚴‍♂️</p>
      </section>

      <section className="terms-content">
        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>SAC MTB</strong>. By accessing or using our website, 
          you agree to comply with the following Terms and Conditions. 
          Please read them carefully before making any purchase or using our services.
        </p>

        <h2>2. Use of Website</h2>
        <ul>
          <li>You must be at least 18 years old or have parental consent to use our website.</li>
          <li>You agree not to misuse the website for illegal or harmful activities.</li>
          <li>All information provided must be accurate and up-to-date.</li>
        </ul>

        <h2>3. Products & Orders</h2>
        <ul>
          <li>All products displayed on our website are subject to availability.</li>
          <li>We reserve the right to modify product specifications or pricing at any time.</li>
          <li>Order confirmation will be sent via email or phone upon successful payment.</li>
        </ul>

        <h2>4. Payments</h2>
        <p>
          Payments must be made through secure gateways supported by SAC MTB. 
          We do not store your card or payment details on our servers.
        </p>

        <h2>5. Shipping & Delivery</h2>
        <p>
          Delivery times may vary depending on your location. We strive to deliver all orders 
          within the estimated time frame mentioned on the website.
        </p>

        <h2>6. Returns & Refunds</h2>
        <p>
          Please refer to our <a href="/returns">Returns Policy</a> page for details on 
          cancellations, returns, and refund eligibility.
        </p>

        <h2>7. Intellectual Property</h2>
        <p>
          All content, logos, and materials on this website are the property of SAC MTB 
          and are protected under copyright law. Unauthorized use or duplication is prohibited.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          SAC MTB will not be held responsible for any direct or indirect damages arising 
          from product use, website access, or service interruptions.
        </p>

        <h2>9. Changes to Terms</h2>
        <p>
          We may update these Terms & Conditions periodically. Continued use of the website 
          after updates implies acceptance of the new terms.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          For any questions regarding these Terms & Conditions, please reach out to us: <br />
          <strong>Email:</strong> support@sacmtb.com <br />
          <strong>WhatsApp:</strong> +91 6396353776
        </p>

        <p className="last-updated">
          <em>Last Updated: November 2025</em>
        </p>
      </section>
    </div>
  );
};

export default TermsPage;
